import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getTopDestinations = async () => {
  const response = await axios.get(`${API_URL}/api/category`);
  return response.data;
};

export const getTravelInterests = async () => {
  const response = await axios.get(`${API_URL}/api/city`);
  return response.data;
};

export const getLatestStories = async () => {
  const response = await axios.get(`${API_URL}/api/placeimage`);
  return response.data;
};
export const getfooterDestinations = async () => {
  const response = await axios.get(`${API_URL}/api/city`);
  return response.data;
};

export const getfooterInterests = async () => {
  const response = await axios.get(`${API_URL}/api/category`);
  return response.data;
};
export const getPlacesByCategoryID = async (
  catid,
  { page = 1, pageSize = 10, search = "" } = {}
) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("pageSize", pageSize);
  if (search) params.append("search", search);

  const response = await axios.get(
    `${API_URL}/api/place/category/${catid}?${params.toString()}`
  );
  return response.data;
};
export const getCountries = async () => {
  const response = await axios.get(`${API_URL}/api/country`);
  return response.data;
};

export const getCitiesByCountryId = async (countryId) => {
  const response = await axios.get(`${API_URL}/api/cityByCountry/${countryId}`);
  return response.data;
};

export const getPlacesByCityId = async (cityId) => {
  const response = await axios.get(`${API_URL}/api/placesByCity/${cityId}`);
  return response.data;
};

export const getPlacesCity = async (cityID) => {
  const response = await axios.get(`${API_URL}/api/placeCity/${cityID}`);
  return response.data;
};
export const getPlacesByCountryID = async (countryID) => {
  const response = await axios.get(
    `${API_URL}/api/placesByCountry/${countryID}`
  );
  return response.data;
};
export const getAllPlaces = async () => {
  const response = await axios.get(`${API_URL}/api/placeWithimage`);
  return response.data;
};
let controller = null;

export const getPlacesWithImage = async ({
  search = "",
  categoryID = "",
  countryID = "",
  cityID = "",
  priceLevel = "",
  page = 1,
  pageSize = 10
} = {}) => {

  // ❗ Cancel previous request before starting a new one
  if (controller) controller.abort();
  controller = new AbortController();

  const params = new URLSearchParams();

  if (search) params.append("search", search);
  if (categoryID) params.append("categoryID", categoryID);
  if (countryID) params.append("countryID", countryID);
  if (cityID) params.append("cityID", cityID);
  if (priceLevel) params.append("priceLevel", priceLevel);

  params.append("page", page);
  params.append("pageSize", pageSize);

  // ❗ Prevent caching
  params.append("_t", Date.now());

  const response = await axios.get(
    `${API_URL}/api/placeWithimage?${params.toString()}`,
    { signal: controller.signal }
  );

  return response.data;
};

export const placeModel = async (placeID) => {
  console.log("Fetching place details for ID:", placeID);
  const response = await axios.get(`${API_URL}/api/placeModel/${placeID}`);
  return response.data;
};
export const cityModel = async (countryID) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/cityModel ${countryID ? `?countryID=${countryID}` : ""}`
    );
    //console.log("Fetched cities:", response.data); // Log the response data
    return response.data;
  } catch (error) {
    console.error("Error fetching cities:", error);
    throw error;
  }
};
export const handleSearch = async (searchTerm) => {
  try {
    const response = await fetch(`${API_URL}/api/search?term=${searchTerm}`);
    const data = await response.json();
    // console.log("Filtered Data:", data);
    // Update your state with the filtered data
    return data;
  } catch (error) {
    console.error("Failed to fetch search results:", error);
  }
};
export const getFilteredPlacesByCity = async (cityID, { categoryID, search, page = 1, limit = 10 } = {}) => {
  const params = new URLSearchParams();
  if (categoryID) params.append("categoryID", categoryID);
  if (search) params.append("search", search);
  params.append("page", page);
  params.append("limit", limit);

  const response = await axios.get(
    `${API_URL}/api/placeCity/${cityID}/filter?${params.toString()}`
  );
  return response.data;
};

export const getCountriesByContinent = async ({ page = 1, pageSize = 10, search = "" } = {}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("pageSize", pageSize);
  if (search) params.append("search", search);

  const response = await axios.get(`${API_URL}/api/country/byContinent?${params.toString()}`);
  return response.data;
};

export const postAd = async ({
  title,
  price,
  snippet,
  description,
  location,
  phone,
  imageFile, // should be a File object
  captcha // <-- add this
}) => {
  const formData = new FormData();
  formData.append("title", title);
  formData.append("price", price);
  formData.append("snippet", snippet);
  formData.append("description", description);
  formData.append("location", location);
  formData.append("phone", phone);
  if (imageFile) {
    formData.append("Image", imageFile);
  }
  if (captcha) {
    formData.append("captcha", captcha); // <-- add this line
  }

  const response = await fetch(`${API_URL}/api/web/ads`, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || "Failed to post ad");
  }

  return await response.json();
};
export const getSimilarPlaces = async (placeID) => {
  const response = await fetch(`${API_URL}/api/placeModel/${placeID}/similar`);
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || "Failed to fetch similar places");
  }
  return await response.json();
};

export const getActiveAds = async ({ page = 1, pageSize = 10, search = "" } = {}) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("pageSize", pageSize);
  if (search) params.append("search", search);

  const response = await axios.get(`${API_URL}/api/adss/active?${params.toString()}`);
  return response.data;
};
export const getAdById = async (id) => {
  const response = await axios.get(`${API_URL}/api/ads/${id}`);
  return response.data;
};
export const getLebanonCities = async () => {
  const response = await axios.get(`${API_URL}/api/citylebanon`);
  return response.data;
};
export const getSiteVisitsSummary = async () => {
  const response = await axios.get(`${API_URL}/api/site/visits/summary`);
  return response.data;
};